// extracted by mini-css-extract-plugin
export default {"main-header":"MainHeader_main-header__+rjQV"};